export const wrapText = (text) => {
  if (!text) return null
  return text.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ))
}
